import { useUserStore, } from '@/assets/js/src/modules/user/_pinia/user'
import { emailRules, } from '@/assets/js/src/util/validation'
import { getActivePinia, storeToRefs, } from 'pinia'
import { ref, computed, getCurrentInstance, } from 'vue'
import { useSnackbarStore, } from '@/assets/js/src/modules/snackbar/_pinia/snackbar'
import { useContactStore, } from '@/assets/js/src/modules/contact/_pinia/contact'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'

export function useContactForm ({ onSuccess, }) {
    if (!onSuccess) {
        debugger
        throw new Error('Please define onSuccess callback')
    }
    const { proxy, } = getCurrentInstance()
    const { t, } = useTranslation()

    let activePinia = getActivePinia()
    let userStore = useUserStore(activePinia)
    let snackbarStore = useSnackbarStore(activePinia)
    let contactForm = useContactStore(activePinia)
    let { user,fullname, } = storeToRefs(userStore)

    let valid = ref(true)
    let email = ref(user.value.email)
    let name = ref(fullname.value)
    let text = ref('')
    let runningApiCall = ref(false)

    let textRules = computed(()=>{
        return [
            (typeof text.value === 'string' && text.value?.trim()?.length !== 0 && text.value.length < 5000) || t('async.contact.max_length_notice'),
        ]
    })

    const submit = async function (event) {

        if ((event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') && !event.shiftKey) {
            return
        }

        let { valid: isValid, } = await proxy.$refs.form.validate()
        if (!isValid) {
            return
        }

        runningApiCall.value = true
        try {
            await contactForm.sendContactMessages(globalThis.clone({
                email: email.value,
                name: name.value,
                text: text.value,
            }))
            await snackbarStore.showMessage({
                message: t('async.contact.success_notice'),
                type: 'success',
            })
            onSuccess()
            // eslint-disable-next-line no-unused-vars
        } catch (e) {
            await snackbarStore.showMessage({
                message: t('async.contact.failed_notice'),
                type: 'error',
            })
        } finally {
            runningApiCall.value = false
        }
    }

    return {
        valid,
        email,
        emailRules,
        name,
        text,
        runningApiCall,
        textRules,
        submit,
    }
}
